import { makeStyles } from "@mui/styles";
// import { Center } from "src/interface/centersIf";


export const useStyles = makeStyles((theme) => ({
  section: {
    margin: theme.spacing(2, 0),
  },
  pageLabel: {
    //color: colors.baselight,
    marginBottom: theme.spacing(1),
    textTransform: "uppercase",
  },
  pageHeader: {
   // color: colors.baseDark,
    marginBottom: theme.spacing(2),
    textTransform: "capitalize",
  },
  responsiveImg: {
    width: "100%",
    height: "auto",
  },
  cardImage: {
    maxHeight: "150px !important",
    overflowY: "hidden",
  },
  cardDataContent:{
    //color: colors.baselight,
    margin: theme.spacing(2, 0),
    justifyContent: "center",
    textTransform: "uppercase",
    marginTop:"center",
    marginBottom:"center",
    textAlign: "center",
    alignContent:"center",
    
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.8rem",
      margin: theme.spacing(1, 0),
    },
  },

  // dashboard
  cardLabel: {
    //color: colors.baselight,
    margin: theme.spacing(2, 0),
    justifyContent: "center",
    textTransform: "uppercase",
    marginTop:"center",
    textAlign: "center",
    alignContent:"center",
    
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.8rem",
      margin: theme.spacing(1, 0),
    },
  },

  cardHeader: {
    //color: colors.baseDark,
    margin: theme.spacing(2, 0),
    marginTop:4,
    justifyContent: "center",
    textTransform: "capitalize",
    textAlign: "center",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.8rem",
      
    },
  },
  displayCard: {
    position: "relative",
    padding: "0px !important",
    minHeight: "140px",
    height: "auto",
  },
  displayCardGraph: {
    width: "100%",
    height: "60px !important",
    position: "absolute",
    bottom: "0px",
    left: "0px",
    [theme.breakpoints.down("xs")]: {
      height: "45px !important",
    },
  },
  ratio: {
    position: "absolute",
    top: "50%",
    left: "33%",
    [theme.breakpoints.down("xs")]: {
      top: "45%",
      left: "25%",
    },
  },
  progressbarContainer: {
    display: "flex",
    flexFlow: "row wrap",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "250px",
  },
  //userOverview section
  cardTitle: {
    //color: colors.baseDark,
  },
  generalGraph: {
    width: "100%",
    height: "300px",
  },

  //footer
  footer: {
    padding: "8px 24px 16px 270px",
    [theme.breakpoints.down("sm")]: {
      padding: "8px 24px 16px 24px",
    },
  },
}));
